import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { disableBodyScroll } from '../../utilities/behavior-helpers/index.js';
import '../../utilities/dom-helpers/index.js';
import img from '../../../../assets/images/cross-icon.svg.js';
import { close, playYtVimeoVideo, handleClickOutside } from './utils/index.js';

class Lightbox extends s {
    constructor() {
        super(...arguments);
        this.closeButtonText = 'Close';
        this.focusStartEl = null;
        this.focusEndEl = null;
        this.playHTML5Video = () => {
            var _a;
            const video = this._content.querySelector('video') ||
                ((_a = this._content.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('video'));
            video.play();
        };
    }
    _initLazyYoutube() {
        const videoPlayer = this._videoPlayerEl;
        if (!(videoPlayer === null || videoPlayer === void 0 ? void 0 : videoPlayer.initAndPlay))
            return false;
        return !!videoPlayer.initAndPlay();
    }
    createRenderRoot() {
        this._container = document.querySelector('.lightboxes-container');
        if (!this._container) {
            this._container = document.createElement('div');
            this._container.className = 'lightboxes-container';
            document.body.append(this._container);
        }
        return this._container;
    }
    connectedCallback() {
        var _a, _b, _c, _d;
        super.connectedCallback();
        // DCCC-8359: the YouTube IFrame API is no longer loaded here on page load;
        // the player is initialised lazily when the lightbox is opened.
        const lightboxHost = this.renderOptions.host;
        const videoSlot = lightboxHost.querySelector('[name="lightbox-video"]');
        if (videoSlot) {
            this.addEventListener('slotchange', () => {
                var _a;
                const items = videoSlot === null || videoSlot === void 0 ? void 0 : videoSlot.assignedElements();
                [this._videoPlayerEl] = items;
                this._content = (_a = items[0].shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.video-container');
            });
        }
        else {
            this._content = lightboxHost.querySelector('[slot="content"]');
            this._videoPlayerEl = ((_b = (_a = this._content) === null || _a === void 0 ? void 0 : _a.matches) === null || _b === void 0 ? void 0 : _b.call(_a, 'video-player, video-player-plus'))
                ? this._content
                : (_d = (_c = this._content) === null || _c === void 0 ? void 0 : _c.querySelector) === null || _d === void 0 ? void 0 : _d.call(_c, 'video-player, video-player-plus');
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('slotchange', () => {
            // this is intentional
        });
    }
    focusTrap() {
        var _a, _b;
        if (!this.focusStartEl) {
            this.focusStartEl = document.createElement('input');
            this.focusStartEl.setAttribute('aria-disabled', 'true');
            this.focusStartEl.setAttribute('aria-hidden', 'true');
        }
        (_a = this.renderRoot.querySelector('.inner')) === null || _a === void 0 ? void 0 : _a.prepend(this.focusStartEl);
        if (!this.focusEndEl) {
            this.focusEndEl = document.createElement('input');
            this.focusEndEl.setAttribute('aria-disabled', 'true');
            this.focusEndEl.setAttribute('aria-hidden', 'true');
            (_b = this.renderRoot.querySelector('.inner')) === null || _b === void 0 ? void 0 : _b.append(this.focusEndEl);
            this.focusEndEl.addEventListener('focus', () => {
                var _a, _b;
                const closeButton = (_b = (_a = this.renderRoot
                    .querySelector('icon-button')) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('button');
                closeButton === null || closeButton === void 0 ? void 0 : closeButton.focus();
            });
        }
        this.focusEndEl.focus();
        this.focusEndEl.blur();
        this.focusStartEl.scrollIntoView({ block: 'end' });
    }
    applyKeydownEvent(element = window) {
        element.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.show) {
                close(this);
            }
        });
    }
    firstUpdated() {
        this.applyKeydownEvent();
    }
    updated() {
        var _a;
        const contentContainer = this._container.querySelector('.content-wrapper');
        if (!contentContainer)
            return;
        if (this.show) {
            contentContainer.appendChild(this._content);
            // YouTube playback (existing player or lazy click-to-load) is handled by
            // the player component itself; only Vimeo/HTML5 use the iframe-src path.
            if (!this._initLazyYoutube()) {
                const videoIframe = this._content.querySelector('iframe') ||
                    ((_a = this._content.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('iframe'));
                if (videoIframe) {
                    playYtVimeoVideo(videoIframe);
                }
                else {
                    this.playHTML5Video();
                }
            }
            setTimeout(() => {
                if (this.show) {
                    disableBodyScroll();
                    this.focusTrap();
                }
            }, 0);
        }
        else {
            while (contentContainer.firstChild) {
                contentContainer.removeChild(contentContainer.lastChild);
            }
        }
    }
    render() {
        return $ `<dialog class="lightbox ${this.show ? 'show' : ''}" ?open="${this.show}" @click="${(e) => handleClickOutside(e, this)}" @keyup="${(e) => {
            if (e.code === 'Escape')
                close(this);
        }}"><div class="inner"><icon-button @click="${() => close(this)}" styleType="light" ariaLabel="${this.closeButtonText}"><img slot="icon" src="${img}" alt="" aria-hidden="true"></icon-button><div class="content-wrapper"><slot name="content"></slot></div></div></dialog>`;
    }
}
__decorate([
    e({ type: Boolean })
], Lightbox.prototype, "show", void 0);
__decorate([
    e()
], Lightbox.prototype, "closeButtonText", void 0);
customElements.define('light-box', Lightbox);

export { Lightbox };
